"use client"

import { useState, useRef, useEffect } from "react"
import Link from "next/link"
import { useRouter } from "next/navigation"
import { Logo } from "@/components/logo"
import { ArrowRight, LogIn, Loader2 } from "lucide-react"
import { Button } from "@/components/ui/button"
import { createClient } from "@/lib/supabase/client"

function LoadingLink({ href, onClick, children, ...props }) {
  const router = useRouter()
  const [loading, setLoading] = useState(false)
  const ref = useRef(null)

  function handleClick(e) {
    e.preventDefault()
    if (ref.current) {
      ref.current.style.minWidth = `${ref.current.offsetWidth}px`
    }
    setLoading(true)
    if (onClick) onClick()
    router.push(href)
  }

  return (
    <Button ref={ref} {...props} onClick={handleClick} disabled={loading}>
      {loading ? (
        <>
          <Loader2 className="h-4 w-4 animate-spin" />
          Loading...
        </>
      ) : children}
    </Button>
  )
}

export function SiteNav() {
  const [user, setUser] = useState(null)
  const [authChecked, setAuthChecked] = useState(false)

  useEffect(() => {
    const supabase = createClient()
    supabase.auth.getUser().then(({ data }) => {
      setUser(data.user)
      setAuthChecked(true)
    })
  }, [])

  return (
    <header className="sticky top-0 z-50 border-b bg-background/80 backdrop-blur-lg">
      <div className="container flex h-16 items-center justify-between px-6 md:px-24">
        <Link href="/">
          <Logo className="h-7 w-auto shrink-0" />
        </Link>
        <div className="flex items-center gap-2">
          {authChecked && !user && (
            <Button size="sm" variant="ghost" className="hidden sm:inline-flex" asChild>
              <Link href="/login">
                <LogIn className="mr-1.5 h-3.5 w-3.5" />
                Sign in
              </Link>
            </Button>
          )}
          <LoadingLink size="sm" href="/app">
            {user ? (
              <>Go to app<ArrowRight className="ml-1.5 h-3.5 w-3.5" /></>
            ) : (
              <>
                <span className="sm:hidden">Try Free</span>
                <span className="hidden sm:inline">Get 350+ Free Questions</span>
                <ArrowRight className="ml-1.5 h-3.5 w-3.5" />
              </>
            )}
          </LoadingLink>
        </div>
      </div>
    </header>
  )
}
